// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2RGGJ","title":"AfterBackImages_title__2HBoz","images":"AfterBackImages_images__4b8rK"};